function innerSize(series = false) {
  let offset = this.offset();
  let width = this.width() - offset.left - offset.right;
  let height = this.height() - offset.top - offset.bottom;
  if (series) return [width, height];
  else return {width, height};
} 

export default innerSize;


// WEBPACK FOOTER //
// ./layouts/default/innerSize.js